<template>
  <div class="photogallery">
    <div class="photogallery__photos" :class="`photogallery__photos--${count}`">
      <AtomsTextLink :href="item.srcLarge" class="photogallery__photos__photo" v-for="(item, index) in photos.slice(0, 6)" :key="item.id" :style="`background-image:url('${item.srcLarge}')`" @click.prevent="openLightBox(index)"></AtomsTextLink>
    </div>
    <div v-if="photos?.length > 6" class="mt-4 text-right">
      <button class="font-bold text-primary-500" @click="openLightBox(7)"><span class="mr-2 underline">{{ $t('Zobrazit další fotky') }}</span> <AtomsImagesIcon icon="arrow-right" size="xs" /></button>
    </div>
    <VueEasyLightbox :visible="lightBoxOpened" :index="lightBoxIndexRef" :imgs="photos.map(photo => photo.srcLarge)" @hide="closeLightBox" />
  </div>
</template>
<script setup>

import VueEasyLightbox from "vue-easy-lightbox";
import "assets/css/lightbox.css";

const props = defineProps({
  id: String
});

const locale = useLocale().getLocale();
const appConfig = useAppConfig();

//#region Lightbox

const lightBoxOpened = ref(false);
const lightBoxIndexRef = ref(0);

const openLightBox = (index) => {
  lightBoxIndexRef.value = index;
  lightBoxOpened.value = true;
}

const closeLightBox = () => lightBoxOpened.value = false;

//#endregion

//#region utils

const getImagePath = (idGalleryImage, sufix = '', format = 'jpg') => {

  format = format.startsWith('.') ? format.slice(1) : format;

  let path = `${useShopZone().value.staticResourcesRoot}/shopFiles/imageGallery/${getImagePathFragment(idGalleryImage)}/${idGalleryImage.toString().padStart(6, '0')}_${sufix}.${format}`;

  return path;
}

const getImagePathFragment = (idGalleryImage) => {
  return Math.floor(idGalleryImage / 100).toString().padStart(6, '0');
}

//#endregion

const galleryData = useState(`galleryPhotos-${props.id}`, () => null);

if (!galleryData.value) {
  galleryData.value = (await useApiFetch(`/api/photogallery?galleryId=${props.id}&languageId=${locale.languageId}`)).imageGallery[0].images;
}

const photos = galleryData.value.items.map((item) => Object.assign({ srcSmall: getImagePath(item.id, 'sm'), srcLarge: getImagePath(item.id, 'lg') }, item));

const count = Math.min(galleryData.value.count, 6);

</script>
<style lang="postcss">
.photogallery {

  &__photos {
    display: -ms-grid;
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }

  &__photos a {
    background-color: #000;
    background-size: cover;
    background-position: center center;
    transition: ease-in-out .1s;
    opacity: .7;
    min-height: 180px;

    &:hover {
      opacity: 1;
    }
  }

  &__photos a:nth-of-type(1) {
    -ms-grid-column: 1;
    grid-column-start: 1;
    -ms-grid-column-span: 1;
    grid-column-end: 2;
    -ms-grid-row: 1;
    grid-row-start: 1;
    -ms-grid-row-span: 2;
    grid-row-end: 3;
  }

  &__photos a:nth-of-type(2) {

    -ms-grid-column: 2;
    grid-column-start: 2;
    -ms-grid-column-span: 1;
    grid-column-end: 3;
    -ms-grid-row: 1;
    grid-row-start: 1;
    -ms-grid-row-span: 1;
    grid-row-end: 2;
  }

  &__photos a:nth-of-type(3) {

    -ms-grid-column: 2;
    grid-column-start: 2;
    -ms-grid-column-span: 1;
    grid-column-end: 3;
    -ms-grid-row: 2;
    grid-row-start: 2;
    -ms-grid-row-span: 1;
    grid-row-end: 3;
  }

  &__photos a:nth-of-type(4),
  &__photos a:nth-of-type(5),
  &__photos a:nth-of-type(6) {
    display: none;
  }

  @screen tablet {

    &__photos a:nth-of-type(4),
    &__photos a:nth-of-type(5),
    &__photos a:nth-of-type(6) {
      display: block;
    }

    &__photos--4 {
      grid-template-columns: 1fr 1fr 2fr;
      grid-template-rows: 1fr 1fr 1fr;
    }

    &__photos--4 a:nth-of-type(1) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 1;
      grid-column-end: 2;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 1;
      grid-row-end: 2;
    }

    &__photos--4 a:nth-of-type(2) {
      -ms-grid-column: 2;
      grid-column-start: 2;
      -ms-grid-column-span: 1;
      grid-column-end: 3;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 1;
      grid-row-end: 2;
    }

    &__photos--4 a:nth-of-type(3) {
      -ms-grid-column: 3;
      grid-column-start: 3;
      -ms-grid-column-span: 1;
      grid-column-end: 4;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 3;
      grid-row-end: 4;
    }

    &__photos--4 a:nth-of-type(4) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 2;
      grid-column-end: 3;
      -ms-grid-row: 2;
      grid-row-start: 2;
      -ms-grid-row-span: 2;
      grid-row-end: 4;
    }

    &__photos--5 {
      grid-template-columns: 1fr 1fr 2fr;
      grid-template-rows: 1fr 1fr 1fr
    }

    &__photos--5 a:nth-of-type(1) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 1;
      grid-column-end: 2;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 1;
      grid-row-end: 2;
    }

    &__photos--5 a:nth-of-type(2) {
      -ms-grid-column: 2;
      grid-column-start: 2;
      -ms-grid-column-span: 1;
      grid-column-end: 3;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 1;
      grid-row-end: 2;
    }

    &__photos--5 a:nth-of-type(3) {
      -ms-grid-column: 3;
      grid-column-start: 3;
      -ms-grid-column-span: 1;
      grid-column-end: 4;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 2;
      grid-row-end: 3;
    }

    &__photos--5 a:nth-of-type(4) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 2;
      grid-column-end: 3;
      -ms-grid-row: 2;
      grid-row-start: 2;
      -ms-grid-row-span: 2;
      grid-row-end: 4;
    }

    &__photos--5 a:nth-of-type(5) {
      -ms-grid-column: 3;
      grid-column-start: 3;
      -ms-grid-column-span: 1;
      grid-column-end: 4;
      -ms-grid-row: 3;
      grid-row-start: 3;
      -ms-grid-row-span: 1;
      grid-row-end: 4;
    }

    &__photos--6 {
      -ms-grid-columns: 1fr 1fr 2fr;
      grid-template-columns: 1fr 1fr 2fr;
      -ms-grid-rows: 5fr 8fr 8fr;
      grid-template-rows: 5fr 8fr 8fr;
    }

    &__photos--6 a:nth-of-type(1) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 1;
      grid-column-end: 2;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 1;
      grid-row-end: 2;
    }

    &__photos--6 a:nth-of-type(2) {
      -ms-grid-column: 2;
      grid-column-start: 2;
      -ms-grid-column-span: 1;
      grid-column-end: 3;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 1;
      grid-row-end: 2;
    }

    &__photos--6 a:nth-of-type(3) {
      -ms-grid-column: 3;
      grid-column-start: 3;
      -ms-grid-column-span: 1;
      grid-column-end: 4;
      -ms-grid-row: 1;
      grid-row-start: 1;
      -ms-grid-row-span: 2;
      grid-row-end: 3;
    }

    &__photos--6 a:nth-of-type(4) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 2;
      grid-column-end: 3;
      -ms-grid-row: 2;
      grid-row-start: 2;
      -ms-grid-row-span: 1;
      grid-row-end: 3;
    }

    &__photos--6 a:nth-of-type(5) {
      -ms-grid-column: 3;
      grid-column-start: 3;
      -ms-grid-column-span: 1;
      grid-column-end: 4;
      -ms-grid-row: 3;
      grid-row-start: 3;
      -ms-grid-row-span: 1;
      grid-row-end: 4;
    }

    &__photos--6 a:nth-of-type(6) {
      -ms-grid-column: 1;
      grid-column-start: 1;
      -ms-grid-column-span: 2;
      grid-column-end: 3;
      -ms-grid-row: 3;
      grid-row-start: 3;
      -ms-grid-row-span: 1;
      grid-row-end: 4;
    }
  }
}
</style>